module.exports = __webpack_public_path__ + "img/stinger-22.41995418.png";